import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';


import Grid from 'front/Grid';
import localStore from 'front/locaStorage';
import React from 'react';
import { useSelector } from 'react-redux';
import { Project } from '../../common/models/projects';
import { selectProjects } from '../../common/selectors/projects';
import { projectSlice } from '../../common/store/projects';
import { AppState, userSelector } from '../../common/store/store';
import { dateColumnType } from '../libraries/GridUtils';
import GridUtils from './GridUtils';


const gridId: string = 'projectDataGrid';

export default () => {

    const user = useSelector((state: AppState) => userSelector.selectById(state, state.device.user?.id ?? 0));
    const [config, _setConfig] = localStore.useLocalStorage(gridId, {});
    const projects = useSelector((state: AppState) => selectProjects(state));

    if (!user) return <></>;

    const columns: GridColDef<Project>[] = [
        GridUtils.baseColDef(config, {
            field: 'id',
            headerName: 'ID',
            width: 40,
            editable: false,
        }),
        GridUtils.baseColDef(config, {
            field: 'client',
            headerName: 'Client',
            editable: true
        }),
        GridUtils.baseColDef(config, {
            field: 'emplacement',
            headerName: 'Emplacement des travaux',
            editable: true
        }),
        GridUtils.baseColDef(config, {
            field: 'debutTravaux',
            headerName: 'Début des trav.',
            editable: true,
            ...dateColumnType,
        }),
        GridUtils.baseColDef(config, {
            field: 'price',
            type: 'number',
            headerName: 'Prix client',
            renderCell: (params: GridRenderCellParams<Project>) => {
                return <Typography>{((params.row.price ?? 0)).toFixed(2) + ' $'}</Typography>;
            },
            editable: true
        }),
        GridUtils.baseColDef(config, {
            field: 'paid',
            type: 'number',
            headerName: 'Montant payé',
            renderCell: (params: GridRenderCellParams<Project>) => {
                return <Typography>{((params.row.paid ?? 0)).toFixed(2) + ' $'}</Typography>;
            },
            editable: true
        }),
        GridUtils.baseColDef(config, {
            field: 'solde',
            type: 'number',
            headerName: 'Solde',
            editable: false,
            renderCell: (params: GridRenderCellParams<Project>) => {
                return <Typography>{((params.row.price ?? 0) - (params.row.paid ?? 0)).toFixed(2) + ' $'}</Typography>;
            }
        }),
        GridUtils.baseColDef(config, {
            field: 'files',
            headerName: 'Documents client',
            editable: false,
            renderCell: GridUtils.GridFilesComponent
        }),
    ];


    return <Box sx={{ width: '100%' }}>
        <Grid
            modelName='projects'
            disableColumnReorder
            gridId={gridId}
            rows={projects}
            columns={columns}
            autoHeight={true}
            slice={projectSlice}
            checkboxSelection
        />
    </Box>;
};
